import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import { StatItem } from '@carbonify/ui';

interface StatBlockRecord extends CdaStructuredTextRecord {
  title?: string;
  subtitle?: string;
  description?: string;
  backgroundColor?: 'light' | 'dark' | 'outline';
  blockSize?: 'sm' | 'md' | 'lg';
}

export default function StatBlock({ title, subtitle, description, backgroundColor, blockSize }: StatBlockRecord) {
  return (
    <StatItem
      value={title}
      label={subtitle}
      note={description}
      color={backgroundColor as StatBlockRecord['backgroundColor']}
      height={blockSize as StatBlockRecord['blockSize']}
      className="self-end shadow-none transition-[box-shadow,transform] hover:-translate-y-1 hover:shadow-sm"
    />
  );
}
